module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M07-clean-a67207b77d7438fc7e90fc55d8d0b5fd.png";